// 디자이너 사진 라이브러리 — 팔레트 '사진' 에서 고르는 저장된 사진(2026-09-22).

import type { SignatureLayoutAssetDto } from '@bhops/shared';
import { apiClient } from './client';
import { signatureTemplatesApi } from './signatureTemplates';

export const signatureLayoutAssetsApi = {
  async list(): Promise<SignatureLayoutAssetDto[]> {
    const { data } = await apiClient.get<SignatureLayoutAssetDto[]>('/signature-layout-assets');
    return data;
  },

  /** 파일 하나를 올려 라이브러리에 넣는다(presigned PUT → 확인). */
  async upload(file: File): Promise<SignatureLayoutAssetDto> {
    const { data: u } = await apiClient.post<{
      assetId: string;
      uploadUrl: string;
      s3Key: string;
      headers: Record<string, string>;
    }>('/signature-layout-assets/upload-url', {
      filename: file.name,
      byteSize: file.size,
      contentType: file.type,
    });
    // PDF 올리기와 같은 PUT(서명된 헤더를 그대로 넘긴다).
    await signatureTemplatesApi.uploadPdf(u.uploadUrl, file, u.headers);
    const { data } = await apiClient.post<SignatureLayoutAssetDto>(
      `/signature-layout-assets/${u.assetId}/confirm`,
      { fileName: file.name, s3Key: u.s3Key, contentType: file.type, byteSize: file.size },
    );
    return data;
  },

  /** 캔버스 사진 주소를 새로 받는다(만료됐거나 아직 모를 때). 허용되지 않은 키는 빠진다. */
  async freshUrls(keys: string[]): Promise<Record<string, string>> {
    if (keys.length === 0) return {};
    const { data } = await apiClient.post<Record<string, string>>('/signature-layout-assets/urls', {
      keys,
    });
    return data;
  },

  async archive(id: string): Promise<void> {
    await apiClient.delete(`/signature-layout-assets/${id}`);
  },
};
